'use strict';

// トースト通知（見た目は components/_toast.scss。マークアップは layouts/_flash が描画する）
// - data-auto-dismiss="true"（success / info）は 6 秒で閉じる。マウスが乗っている間・フォーカスがある間は止める
// - error / warning は自動では閉じず、×ボタンで閉じる
// - 表示したままキャッシュされると戻るボタンで再表示されるため、キャッシュ前に取り除く
// document へのイベント委譲なので turbolinks:load の外で 1 回だけ登録する
(function () {
  const AUTO_DISMISS_MS = 6000;
  const LEAVE_MS = 200; // _toast.scss の .is-leaving の transition と揃える
  const TIMER_KEY = 'toastTimer';

  function stopTimer($toast) {
    clearTimeout($toast.data(TIMER_KEY));
  }

  function dismiss($toast) {
    if ($toast.hasClass('is-leaving')) return;
    stopTimer($toast);
    $toast.addClass('is-leaving');
    setTimeout(function () {
      $toast.remove();
    }, LEAVE_MS);
  }

  function startTimer($toast) {
    if ($toast.attr('data-auto-dismiss') !== 'true') return;
    stopTimer($toast);
    $toast.data(TIMER_KEY, setTimeout(function () {
      dismiss($toast);
    }, AUTO_DISMISS_MS));
  }

  // 操作中（マウスが乗っている・フォーカスがある）なら止めたままにする
  function resumeTimer(toast) {
    if (toast.matches(':hover') || toast.contains(document.activeElement)) return;
    startTimer($(toast));
  }

  $(document).on('turbolinks:load', function () {
    $('.js-toast').each(function () {
      startTimer($(this));
    });
  });

  $(document).on('click', '.js-toast-close', function () {
    dismiss($(this).closest('.js-toast'));
  });

  $(document).on('mouseenter focusin', '.js-toast', function () {
    stopTimer($(this));
  });

  $(document).on('mouseleave', '.js-toast', function () {
    resumeTimer(this);
  });

  // focusout の時点では activeElement が移り切っていないため、次のフォーカス先で判定する
  $(document).on('focusout', '.js-toast', function (event) {
    if (event.relatedTarget && this.contains(event.relatedTarget)) return;
    if (this.matches(':hover')) return;
    startTimer($(this));
  });

  $(document).on('turbolinks:before-cache', function () {
    $('.js-toast').each(function () {
      stopTimer($(this));
    }).remove();
  });
})();
